module.exports = __webpack_public_path__ + "img/application-window.1cf329b5.svg";